//!#system	

<template>
	<div>
		<fieldset :class="classesForGroup">
			<legend>{{groupTitle}}</legend>
			<span class="addGroupBtnSpan">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" @click="addAnotherGroup()" class="mx-2" fab dark small color="teal">
							<v-icon dark small>mdi-plus</v-icon>
						</v-btn>
					</template>
					<span>Add another matching rule group</span>
				</v-tooltip>
			</span>
			<span class="removeGroupBtnSpan" v-if="hasRemoveOption">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn @click="removeThisGroup()" v-on="on" class="mx-2" fab dark small color="warning">
							<v-icon dark small>mdi-minus</v-icon>
						</v-btn>
					</template>
					<span>Remove this group</span>
				</v-tooltip>
			</span>
			<v-select
				v-model="model.matchType"
				:items="matchTypes"
				label="Match"
				:disabled="matchTypes.length <= 0"
				@input="updateModel()"
			></v-select>
			<div v-for="(matcher, index) in model.matchers" :key="matcher.sig">
				<rules-item v-if="model.matchers[index].type === 'simple'" v-model="model.matchers[index]" :bucket="bucket" @remove="removeGroup(model.matchers, index, model.matchers[index].sig);" :routeInfo="routeInfo" @input="updateModel" />
				<rules-group v-if="model.matchers[index].type === 'group'" v-model="model.matchers[index]" :bucket="bucket" @remove="removeGroup(model.matchers, index, model.matchers[index].sig);" :routeInfo="routeInfo" />
			</div>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="addMatcher()" color="secondary" fab x-small dark>
						<v-icon dark x-small>mdi-plus</v-icon>
					</v-btn>
				</template>
				<span>Add a field/JSON path</span>
			</v-tooltip>
		</fieldset>
	</div>
</template>


<script>
	import RulesItem from '@/components/pieces/RulesItem';

	const baseKey = function(start, end) {
		return Math.floor(Math.random() * end) + start;
	};

	const defaultGroup = function() {
		return {
			sig: 'group-' + baseKey(1, 600),
			type: 'group',
			matchType: 'All',
			matchers: [defaultMatcher()]
		};
	};

	const defaultMatcher = function(type) {
		return {
			sig: 'item-' + baseKey(1000, 6000),
			type: type || 'simple',
			path: '',
			operator: 'is',
			value: ''
		};	
	};

	export default {
		name: 'rulesGroup',
		props: {
			routeInfo: {
				type: Object
			},
			value: {
				type: Object
			},
			bucket: {
				type: String
			}
		},
		data() {
			return {
				matchTypes: ['All', 'Any', 'Not'],
				model: this.value.type ? this.value : {
					type: 'group',
					matchType: 'All',
					matchers: [defaultMatcher()]
				}
			};
		},
		computed: {
			hasRemoveOption() {
				return this.$listeners && this.$listeners.remove
			},
			classesForGroup() {
				const matchClasses = {
					'All': 'groupIsAll',
					'Any': 'groupIsAny',
					'Not': 'groupIsNot'
				};
				return ['group', matchClasses[this.model.matchType]].join(' ');
			},
			groupTitle() {
				if (this.model.matchType === 'All') {
					return 'Rules: All of these must be true'
				}
				if (this.model.matchType === 'Any') {
					return 'Rules: Any of these can be true'
				}
				if (this.model.matchType === 'Not') {
					return 'Rules: Any of these should be false'
				}
				return 'Matching rules';
			}
		},
		methods: {
			addAnotherGroup() {
				this.model.matchers.push(defaultGroup());
				this.updateModel();
			},
			updateModel() {
				this.$emit('input', this.model);
			},
			addMatcher() {
				this.model.matchers.push(defaultMatcher());
				this.updateModel();
			},
			removeGroup(model, index, sig) {
				console.log('removeGroup', index, sig, this.model);
				//model.splice(index, 1);
				this.$delete(model, index);
				let indexToDelete = 0;
				for (let i = 0; i < model.length; i++) {
					if (sig && model[i].sig === sig) {
						console.log(model[i].sig, sig);
						this.$delete(model, i);
					}
				}
				this.updateModel();
				//this.$forceUpdate();
			},
			removeThisGroup() {
				this.$emit('remove');
			}
		},
		components: {
			RulesItem
		}
	};
</script>

<style scoped>
.group {
	padding: 20px;
	border: 3px solid #eee;
	position: relative;
	margin-bottom: 20px;
}
.groupIsAny {
	border: 3px solid #56A99D;
}
.groupIsAll {
	border: 3px solid #7752AD;
}
.groupIsNot {
	border: 3px solid #FFD54F;
}
.group legend {
	padding: 0 20px 0 20px;
}
.addGroupBtnSpan {
	position: absolute;
	right: 50px;
	top: 0px;
}
.removeGroupBtnSpan {
	position: absolute;
	right:0px;
	top: 0px;
}
</style>